import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('HH:MM');

export default class TimeFieldMask extends PureComponent {

  static propTypes = {
    inputRef: PropTypes.func.isRequired,
  };

  timeMask = (value) => {
    const chars = value.split('');
    const hours = [
      /[0-2]/,
      chars[0] === '2' ? /[0-3]/ : /[0-9]/,
    ];
    const minutes = [ /[0-5]/, /[0-9]/ ];
    return hours.concat(':').concat(minutes);
  };

  render = () =>
    <MaskedInput
      {...omit(this.props, [ 'inputRef' ])}
      ref={(ref) => this.props.inputRef(ref ? ref.inputElement : null)}
      pipe={autoCorrectedDatePipe}
      mask={this.timeMask}
      showMask
    />;

}
